import {createReducer, isAnyOf} from '@reduxjs/toolkit'
import {HttpError} from '@wix/http-client'
import {RegistrationErrorKey} from '../../../../commons/enums'
import {PLACE_ORDER_OLD, UPDATE_ORDER_OLD, getOrder, placeOrder, updateOrder} from '../actions/placed-order'
import {RESERVE_TICKETS_OLD, makeReservation} from '../actions/reservation'
import {
  RESET_RSVP_ERROR_OLD,
  SEND_RSVP_OLD,
  UPDATE_RSVP_OLD,
  resetRsvpError,
  sendRsvp,
  updateRsvp,
} from '../actions/rsvp'
import {FormSubmitErrors} from '../types/state'

const getDefaultState = (): FormSubmitErrors => ({
  error: {},
  errorTime: null,
  canRetry: false,
})

export const formSubmitErrors = createReducer(getDefaultState(), builder => {
  builder
    .addMatcher(
      action =>
        action.type === SEND_RSVP_OLD.FAILURE ||
        action.type === PLACE_ORDER_OLD.FAILURE ||
        action.type === UPDATE_ORDER_OLD.FAILURE ||
        action.type === UPDATE_RSVP_OLD.FAILURE,
      (state, action) => {
        const error: HttpError = action.error

        state.error = error?.response?.data?.metadata ?? {error_key: RegistrationErrorKey.UNKNOWN_REGISTRATION_ERROR}
        state.canRetry = canRetryError(error)
        state.errorTime = new Date()
      },
    )
    .addMatcher(
      isAnyOf(placeOrder.rejected, updateOrder.rejected, sendRsvp.rejected, updateRsvp.rejected),
      (state, action) => {
        const error: HttpError = action.payload as HttpError

        state.error = error?.response?.data?.metadata ?? {error_key: RegistrationErrorKey.UNKNOWN_REGISTRATION_ERROR}
        state.canRetry = canRetryError(error)
        state.errorTime = new Date()
      },
    )
    .addMatcher(
      action =>
        action.type === RESET_RSVP_ERROR_OLD ||
        action.type === PLACE_ORDER_OLD.SUCCESS ||
        action.type === UPDATE_ORDER_OLD.SUCCESS ||
        action.type === RESERVE_TICKETS_OLD.REQUEST ||
        action.type === UPDATE_RSVP_OLD.SUCCESS ||
        isAnyOf(
          resetRsvpError,
          placeOrder.fulfilled,
          updateOrder.fulfilled,
          getOrder.fulfilled,
          makeReservation.pending,
          updateRsvp.fulfilled,
        )(action),
      state => {
        state.error = {}
        state.errorTime = null
        state.canRetry = false
      },
    )
})

const canRetryError = (error: HttpError) => {
  return error?.response?.status > 500 || error?.response?.status === 429
}
